import flow from 'lodash/flow';
import get from 'lodash/get';
import withLotameTargeting from 'src/common/decorators/ads/withLotameTargeting';
import connectAsync from '../../utils/connectAsync';
import parse from '../../utils/queryString/parse';
import withAdScreenRequest from '../../decorators/ads/withAdScreenRequest';
import { getSearchScreenType } from '../utils/adScreenTypes';
import { performSearch, performPrepopulateSearch } from '../../actions/search';
import { disableLoadingState } from '../../constants/locationState';
import { FM_SEARCH_PREPOPULATE_GUIDE_ID } from '../../constants/experiments/search';
import SearchLoader from './SearchLoader';

function asyncSearch({ location, store }) {
  const queryProp = get(location, 'query.query', '');
  const queryToken = get(location, 'query.itemtoken');
  const parsedSearch = parse(get(location, 'search', '')); // lowercases the keys

  const { query, itemtoken: searchToken } = parsedSearch;

  const itemToken = queryToken || searchToken;
  const queryString = queryProp || query;

  const searchQueryObj = {
    query: queryString,
    [disableLoadingState]: get(location, ['state', disableLoadingState]),
  };

  if (itemToken) {
    searchQueryObj.itemToken = itemToken;
  }

  if (queryString) {
    return performSearch(searchQueryObj);
  }
  const guideId = get(store.getState(), [
    'config',
    'autoupdate',
    FM_SEARCH_PREPOPULATE_GUIDE_ID,
  ]);
  return guideId && performPrepopulateSearch({ query: guideId });
}

export default flow(
  withAdScreenRequest(getSearchScreenType),
  withLotameTargeting,
  connectAsync([asyncSearch]),
)(SearchLoader);
